
/**
 * Build Your Bundle — bundle builder
 * Works on any container marked [data-byr]. Cards are read straight out of
 * the DOM (data-id / data-variant-id / data-title / data-price / data-image /
 * data-available), so it doesn't matter how many products are in each
 * category — everything rendered by Liquid is automatically pickup-able.
 * Multi-variant products use [data-byr-variants] buttons to select a variant
 * before adding to the bundle.
 *
 * Quantity: each bundle slot is one unit, so the same product (or variant)
 * can fill several slots. Cards show "Add to Bundle" until added, then a
 * − / count / + stepper for the currently selected variant.
 */
(function () {
  'use strict';
 
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
 
  function initBuilder(root) {
    var tier1Qty = parseInt(root.dataset.tier1Qty, 10) || 3;
    var tier1Pct = parseInt(root.dataset.tier1Pct, 10) || 10;
    var tier2Qty = parseInt(root.dataset.tier2Qty, 10) || 4;
    var tier2Pct = parseInt(root.dataset.tier2Pct, 10) || 15;
 
    var tierButtons = root.querySelectorAll('[data-byr-tier]');
    var slotsEl = root.querySelector('[data-byr-slots]');
    var totalEl = root.querySelector('[data-byr-total]');
    var savingsEl = root.querySelector('[data-byr-savings]');
    var ctaEl = root.querySelector('[data-byr-cta]');
    var msgEl = root.querySelector('[data-byr-msg]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-byr-card]'));
 
    var currentTier = { qty: tier1Qty, pct: tier1Pct };
    var selected = []; // one entry per unit: { card, id, variantId, title, priceCents, image }
 
    function dollarsToCents(str) {
      var num = parseFloat(String(str).replace(/[^0-9.]/g, ''));
      return Math.round((isNaN(num) ? 0 : num) * 100);
    }
 
    function countFor(card, variantId) {
      return selected.filter(function (i) {
        return i.card === card && i.variantId === variantId;
      }).length;
    }
 
    /* Syncs a card's button/stepper with how many of its selected variant are in the bundle */
    function refreshCard(card) {
      var n = countFor(card, card.dataset.variantId);
      var anyForCard = selected.some(function (i) { return i.card === card; });
      card.classList.toggle('is-added', anyForCard);
 
      var addBtn = card.querySelector('[data-byr-add]');
      var qtyEl = card.querySelector('[data-byr-qty]');
      var countEl = card.querySelector('[data-byr-qty-count]');
      if (addBtn) addBtn.hidden = n > 0;
      if (qtyEl) qtyEl.hidden = n === 0;
      if (countEl) countEl.textContent = n;
    }
 
    function render() {
      renderSlots();
      renderTotals();
      cards.forEach(refreshCard);
    }
 
    function setTier(qty, pct, btn) {
      currentTier = { qty: qty, pct: pct };
      tierButtons.forEach(function (b) {
        b.classList.toggle('byr__tier--active', b === btn);
      });
      while (selected.length > currentTier.qty) {
        selected.pop();
      }
      render();
    }
 
    function renderSlots() {
      slotsEl.innerHTML = '';
      slotsEl.style.gridTemplateColumns = 'repeat(' + currentTier.qty + ', 1fr)';
      for (var i = 0; i < currentTier.qty; i++) {
        var slot = document.createElement('div');
        slot.className = 'byr__slot';
        var item = selected[i];
        if (item) {
          slot.classList.add('is-filled');
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title;
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'byr__slot-remove';
          remove.setAttribute('aria-label', 'Remove ' + item.title);
          remove.textContent = '\u00D7';
          remove.addEventListener('click', function (idx) {
            return function () { removeAt(idx); };
          }(i));
          slot.appendChild(img);
          slot.appendChild(remove);
        } else {
          slot.textContent = 'Select Product';
        }
        slotsEl.appendChild(slot);
      }
    }
 
    function renderTotals() {
      var totalCents = selected.reduce(function (sum, i) { return sum + i.priceCents; }, 0);
      totalEl.textContent = money(totalCents);
 
      if (selected.length > 0) {
        var discountCents = Math.round(totalCents * (currentTier.pct / 100));
        savingsEl.hidden = false;
        savingsEl.textContent =
          'You save ' + money(discountCents) + ' (' + currentTier.pct + '%) \u2014 applied automatically at checkout';
      } else {
        savingsEl.hidden = true;
      }
 
      var full = selected.length === currentTier.qty;
      ctaEl.disabled = !full;
      ctaEl.textContent = full
        ? (root.dataset.ctaLabel || 'Add Bundle to Cart')
        : 'Select ' + (currentTier.qty - selected.length) + ' More Product' + (currentTier.qty - selected.length === 1 ? '' : 's');
    }
 
    function removeAt(index) {
      if (!selected[index]) return;
      selected.splice(index, 1);
      render();
      setMsg('');
    }
 
    /* Adds one unit of the card's currently selected variant */
    function addUnit(card) {
      if (selected.length >= currentTier.qty) {
        setMsg('Your bundle is full \u2014 remove an item to add a new one.', true);
        return;
      }
      selected.push({
        card: card,
        id: card.dataset.id,
        variantId: card.dataset.variantId,
        title: card.dataset.title,
        priceCents: dollarsToCents(card.dataset.price),
        image: card.dataset.image
      });
      render();
      setMsg('');
    }
 
    /* Removes the most recently added unit of the card's currently selected variant */
    function removeUnit(card) {
      for (var i = selected.length - 1; i >= 0; i--) {
        if (selected[i].card === card && selected[i].variantId === card.dataset.variantId) {
          removeAt(i);
          return;
        }
      }
    }
 
    function setMsg(text, isError) {
      msgEl.textContent = text || '';
      msgEl.classList.toggle('is-error', !!isError);
      msgEl.classList.toggle('is-success', false);
    }
 
    function addBundleToCart() {
      if (selected.length !== currentTier.qty) return;
      ctaEl.disabled = true;
      ctaEl.textContent = 'Adding...';
      setMsg('');
 
      /* Combine repeat units of the same variant into one line with a quantity */
      var lines = {};
      var items = [];
      selected.forEach(function (i) {
        if (lines[i.variantId]) {
          lines[i.variantId].quantity += 1;
          return;
        }
        var line = {
          id: parseInt(i.variantId, 10),
          quantity: 1,
          properties: { '_Bundle Builder': 'Build Your Bundle' }
        };
        lines[i.variantId] = line;
        items.push(line);
      });
 
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err && err.description ? err.description : 'Something went wrong adding your bundle.');
            });
          }
          return res.json();
        })
        .then(function () {
          setMsg('Added to cart! Redirecting...', false);
          msgEl.classList.add('is-success');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          setMsg(err.message || 'Something went wrong. Please try again.', true);
          ctaEl.disabled = false;
          renderTotals();
        });
    }
 
    /* Variant button handling — switches which variant the card's
       Add / stepper controls act on. Units already in the bundle keep
       their own variant, so a shopper can mix variants of one product. */
    cards.forEach(function (card) {
      var variantBtns = Array.prototype.slice.call(card.querySelectorAll('[data-byr-variant]'));
      if (variantBtns.length === 0) return;
 
      variantBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          variantBtns.forEach(function (b) {
            b.classList.remove('byr__variant-btn--active');
          });
          btn.classList.add('byr__variant-btn--active');
          card.dataset.variantId = btn.dataset.variantId;
          card.dataset.price = btn.dataset.variantPrice;
          refreshCard(card);
        });
      });
    });
 
    tierButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTier(parseInt(btn.dataset.byrTier, 10), parseInt(btn.dataset.byrPct, 10), btn);
      });
    });
 
    cards.forEach(function (card) {
      if (card.dataset.available === 'false') return;
      var addBtn = card.querySelector('[data-byr-add]');
      var plusBtn = card.querySelector('[data-byr-qty-plus]');
      var minusBtn = card.querySelector('[data-byr-qty-minus]');
      if (addBtn) addBtn.addEventListener('click', function () { addUnit(card); });
      if (plusBtn) plusBtn.addEventListener('click', function () { addUnit(card); });
      if (minusBtn) minusBtn.addEventListener('click', function () { removeUnit(card); });
    });
 
    if (ctaEl) {
      ctaEl.addEventListener('click', addBundleToCart);
    }
 
    render();
  }
 
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-byr]').forEach(initBuilder);
  });
})();
